import React, { useState, useEffect, useRef } from 'react';

const Participant = (props) => {
    const [videoTracks, setVideoTracks] = useState([]);
    const [audioTracks, setAudioTracks] = useState([]);
    const [tiempo, setTiempo] = useState(false);
    const videoRef = useRef();
    const audioRef = useRef();

    useEffect(()=>{
        const trackSubscribed = track => {
            if (track.kind === 'video') {
                setVideoTracks(videoTracks => [...videoTracks, track]);
            } else {
                setAudioTracks(audioTracks => [...audioTracks, track]);
            }
        };
        const trackUnsubscribed = track => {
            if (track.kind === 'video') {
                setVideoTracks(videoTracks => videoTracks.filter(v => v !== track));
            } else {
                setAudioTracks(audioTracks => audioTracks.filter(a => a !== track));
            }
        };
        setVideoTracks(trackpubsToTracks(props.participant.videoTracks));
        setAudioTracks(trackpubsToTracks(props.participant.audioTracks));
       // setTiempo(props.tiempo)

        props.participant.on('trackSubscribed', trackSubscribed);
        props.participant.on('trackUnsubscribed', trackUnsubscribed);

        return () => { 
            setVideoTracks([]);
            setAudioTracks([]);
            props.participant.removeAllListeners();
        };
    }, [props.participant])

    useEffect(() => {
        const videoTrack = videoTracks[0];
        if (videoTrack) {
            videoTrack.attach(videoRef.current);
            return () => {
                videoTrack.detach();
            };
        }
    }, [videoTracks]);

    
    useEffect(() => {
        const audioTrack = audioTracks[0];
        if (audioTrack) {
            audioTrack.attach(videoRef.current);
            return () => {
                audioTrack.detach();
            };
        }
    }, [audioTracks]);

    const trackpubsToTracks = trackMap => Array.from(trackMap.values())
        .map(publication => publication.track)
        .filter(track => track !== null);
        //<p>{participant.identity}</p>
       
    return (
        <div className="participant">
          
            <video ref={videoRef} autoPlay={true} />
            <audio ref={audioRef} autoPlay={true} muted={true} />
        </div>
    );
};

export default Participant;